var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import React, { Component } from "react";
class EditableTextInput extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "handleFocus", (e) => {
      e.stopPropagation();
      this.props.setFocusToBlock();
      this.props.setInPluginEditingMode(true);
    });
    __publicField(this, "handleBlur", () => this.props.setInPluginEditingMode(false));
    __publicField(this, "handleKeyPress", (e) => {
      const { setFocusToBlock, value } = this.props;
      if (e.key === "Enter" && setFocusToBlock && value !== "") {
        this.handleBlur();
        setFocusToBlock();
      }
    });
  }
  render() {
    const { InputComponent, value, onChange } = this.props;
    const props = {
      value,
      onChange,
      onFocus: this.handleFocus,
      onBlur: this.handleBlur,
      onKeyPress: this.handleKeyPress,
      dir: "auto"
    };
    return React.cloneElement(InputComponent, props);
  }
}
var EditableInputWrapper_default = EditableTextInput;
export {
  EditableInputWrapper_default as default
};
//# sourceMappingURL=EditableInputWrapper.js.map
